define('Store.Cart.CartDisableError.View', [
    'store-cart-detail-message.tpl',
    'SC.Configuration',
    'Backbone'
], function ModuleName(
    storeCartDetailMessageTpl,
    Configuration,
    Backbone
) {
    'use strict';

    return Backbone.View.extend({
        template: storeCartDetailMessageTpl,
        getContext: function getContext() {
            return {
                cartDisabledItemsMessage: Configuration.get('store.selector.messages.cartDisabledItems')
            };
        }
    });
});
